'use client';
import * as actions from '@/actions';
import { useTranslation } from '@/app/i18n/client';

const ButtonLogIn = ({
    attributes,
    priority,
    itemLength,
    enableLogin,
    isHaveSignOut,
    isGuest,
    colorStyle,
}: {
    attributes: any;
    priority: number;
    itemLength: number;
    enableLogin: boolean;
    isHaveSignOut: boolean;
    isGuest: boolean;
    colorStyle: any;
}) => {
    const { t } = useTranslation();

    return (
        <div
            id="header-cp-signinout-item-container"
            className={`flex flex-row py-1 items-center hover:opacity-50
        relative flex-shrink-0 ${priority == 0 ? 'pl-6' : ''} ${
            priority == itemLength - 1 ? 'pr-6' : ''
        }`}
        >
            {enableLogin && (
                <>
                    {/* Guest sees Sign In, not Sign Out — a guest session isn't a login */}
                    {isHaveSignOut && !isGuest ? (
                        <button
                            id="header-cp-signinout-item-signout"
                            className="font-light text-xs"
                            style={{ color: colorStyle?.text || '#3d3d3d' }}
                            onClick={async () => {
                                await actions.signOut();
                                window.location.href = '/';
                            }}
                        >
                            {t('navigation.logout')}
                        </button>
                    ) : (
                        <a
                            id="header-cp-signinout-item-signin"
                            href="/signin"
                            rel="noopener noreferrer"
                            className="font-light text-xs"
                            style={{ color: colorStyle?.text || '#3d3d3d' }}
                        >
                            {t('navigation.login')}
                        </a>
                    )}
                </>
            )}
        </div>
    );
};

export default ButtonLogIn;
